var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.time)),_c('span',[_vm._v(_vm._s(_vm.time_span))])])])}
var staticRenderFns = []

export { render, staticRenderFns }